import { Addon, Subscription } from '@futrli-sdk/billing';
import { AnyError } from '@futrli/errors';
import { formatMinorUnitsAmount, WrappedComponentProps } from '@futrli/localisation';
import { TrackerType } from '@futrli/shared-services';
import { eventTracker } from '@futrli/tracking';
import { isArray } from 'lodash';

import { injector } from './injector';
import { BillingProduct } from './types';
import { isStripeAPIError, DEFAULT_ERROR_FORM_MESSAGE } from '../utils/error-utils';
import { getSubscriptionId } from '../utils/utils';

export const getTracker = () => {
  return injector.get('Tracker') as TrackerType;
};

export const { trackCTA, trackEvent, trackViewModal } = eventTracker(getTracker);

export const trackPaymentError = (productName: string, error: AnyError, isSetupIntentFlow?: boolean) => {
  const tracker = getTracker();
  const errorData = error?.response?.data;
  let message = isArray(errorData) ? errorData[0] : errorData?.message;

  if (!message && isStripeAPIError(error)) {
    message = error?.message;
  }

  if (!message) {
    message = DEFAULT_ERROR_FORM_MESSAGE;
  }

  tracker.track(isSetupIntentFlow ? 'Error storing payment details' : `Payment failed for ${productName}`, {
    'Fail reason:': message
  });
};

export function trackPaymentSuccess(
  product: BillingProduct,
  intl: WrappedComponentProps['intl'],
  subscription: Subscription,
  paymentAmount: number
): void {
  if (paymentAmount === 0) {
    return trackEvent('Payment details successfully stored');
  }

  const eventTitle = `Payment successful for ${product.name}`;
  const productAddon = subscription.addons.find(addon => addon.name === product.slug) as Addon;

  trackEvent(eventTitle, {
    subscription_plan_id: getSubscriptionId(subscription),
    subscription_term: subscription.term,
    Amount: formatMinorUnitsAmount(paymentAmount, subscription.currency_code, intl),
    [`licence_${productAddon.id}_quantity`]: productAddon.quantity
  });
}
